import { createEventString, log } from "@/utils/log";
import getErrorMessage from "@/utils/getErrorMessage";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";

const Payment = ({
  publishableStripeKey,
  children,
}: {
  publishableStripeKey: string;
  children: (cardElement: any, stripe: any) => JSX.Element;
}) => {
  const [stripe, setStripe] = useState<any>(null);
  const [stripeError, setStripeError] = useState<string | null>(null);
  const [cardElement, setCardElement] = useState<any>(undefined);

  useEffect(() => {
    (async () => {
      try {
        const loadedStripe = await loadStripe(publishableStripeKey);
        setStripe(loadedStripe);
      } catch (error) {
        setStripeError(
          "There was a problem loading our payment processor. " +
            "Please turn off any ad blockers, reload the page, and try again. " +
            "If that still doesn't work, you can close this modal and reach support via the chatbox in the lower right hand corner of the page."
        );
        const message = getErrorMessage(error);
        log({
          eventName: createEventString("stripe", "error", "load"),
          eventMessage: "Error loading Stripe",
          eventData: {
            error,
            error_message: message,
          },
          eventLevel: "error",
        });
      }
    })();
  }, [publishableStripeKey]);

  useEffect(() => {
    (async () => {
      if (stripe) {
        const elements = stripe.elements();

        const cardElement = elements.create("card", {
          style: {
            base: {
              color: "#000",
              fontWeight: "500",
              fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
              fontSize: "16px",
              fontSmoothing: "antialiased",
              ":-webkit-autofill": {
                color: "#fce883",
              },
              padding: "16px",
            },
            invalid: {
              // iconColor: '#FFC7EE',
              // color: '#FFC7EE',
            },
          },
        });

        cardElement.mount("#card");
        setCardElement(cardElement);
        cardElement.on("ready", () => {
          cardElement.focus();
        });
      }
    })();
  }, [stripe]);

  return (
    <div>
      {stripeError && <div>{stripeError}</div>}
      <div className="mt-2">Payment</div>
      <div className="border border-gray-100 rounded p-4 flex-1 h-14">
        <div id="card" />
      </div>
      {children(cardElement, stripe)}
    </div>
  );
};

export default Payment;
